// main.tsx
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { PostHogProvider } from 'posthog-js/react'
import { posthogClient } from './posthogClient'
import { StyledEngineProvider } from '@mui/material/styles'
import GlobalStyles from '@mui/material/GlobalStyles'

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <StyledEngineProvider enableCssLayer>
            <GlobalStyles styles="@layer tw, theme, base, mui, components, utilities;" />
            {posthogClient ? (
                <PostHogProvider client={posthogClient}>
                    <App />
                </PostHogProvider>
            ) : (
                <App /> // No PostHog at all
            )}
        </StyledEngineProvider>
    </StrictMode>,
)
